const ExtractRouteQueryParams = (): string[] => {
	const urlElements = window.location.href.split("?");

	const queryElements = urlElements[1].split("&");

	return queryElements;
};

export default ExtractRouteQueryParams;
